// GAVION gavion-context: the « Contexte Gavion » that Formation → « Tout sur Gavion » shows.
import { companyContextFromAi } from "../../../../supabase/functions/_shared/ai/companyContext.ts";

type Obj = Record<string, unknown>;
const obj = (v: unknown): Obj =>
  typeof v === "object" && v !== null && !Array.isArray(v) ? (v as Obj) : {};

/** The stored context (configuration gavion.ai.company_context), else the default: the AI's own fallback. */
export const gavionContextOf = (config: unknown): string =>
  companyContextFromAi(obj(obj(config).gavion).ai);
